import { render, staticRenderFns } from "./customInp.vue?vue&type=template&id=4a9fbcd6"
import script from "./customInp.vue?vue&type=script&lang=js"
export * from "./customInp.vue?vue&type=script&lang=js"
import style0 from "./customInp.vue?vue&type=style&index=0&id=4a9fbcd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports